import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export class TeaserListSlider {
  constructor(target) {
    this.section = target;
  }

  init() {
    if (!this.section || CMS.editMode) {
      return;
    }

    const config = {
      slidesPerView: 1,
      spaceBetween: 16,
      enabled: true,
      a11y: {
        slideRole: 'presentation',
        slideLabelMessage: ''
      },
      breakpoints: {
        640: {
          slidesPerView: 'auto',
          spaceBetween: 0,
          enabled: false
        }
      },
      pagination: {
        el: this.section.querySelector('.swiper-pagination'),
        clickable: true
      },
      modules: [Pagination]
    };

    const sliderElement = this.section.querySelector('.swiper');

    new Swiper(sliderElement, config);

    this.loading(false);
  }

  loading(isLoading = true) {
    this.section.classList.toggle('loading', isLoading);
  }
}
